// Drag on touch screens (iPad / phone) for the week board: HTML5 drag does not fire on touch. Press and hold a job, then move it to a cell ([data-day] [data-tech]); moving
// the finger before the hold ends scrolls the board as usual. Plain DOM, no library.
import { useRef } from 'react'

export const HOLD_MS = 280
export const MOVE_TOLERANCE = 10
export const isCoarsePointer = () => typeof window !== 'undefined' && !!window.matchMedia && window.matchMedia('(pointer: coarse)').matches
// what is under the finger -> { day, tech } or null
export function cellAt(el) {
  const c = el && el.closest ? el.closest('[data-day]') : null
  return c ? { el: c, day: c.getAttribute('data-day'), tech: c.getAttribute('data-tech') || null } : null
}
export function useTouchDrag(onDrop) {
  const justDragged = useRef(false)
  const start = (e, id, label) => {
    if (!e.touches || e.touches.length !== 1) return
    const t0 = e.touches[0]
    let active = false, ghost = null, cell = null
    const paint = c => { if (cell && cell.el !== (c && c.el)) cell.el.style.outline = ''; if (c) c.el.style.outline = '2px solid #1B4FD8'; cell = c }
    const cleanup = () => {
      clearTimeout(timer)
      document.removeEventListener('touchmove', move); document.removeEventListener('touchend', end); document.removeEventListener('touchcancel', cancel)
      if (ghost) ghost.remove()
      paint(null)
    }
    const place = (x, y) => { if (ghost) { ghost.style.left = x + 12 + 'px'; ghost.style.top = y - 40 + 'px' } }
    const timer = setTimeout(() => {
      active = true
      ghost = document.createElement('div')
      ghost.textContent = label
      ghost.setAttribute('data-service', 'drag-ghost')
      ghost.style.cssText = 'position:fixed;z-index:3000;pointer-events:none;background:#1B4FD8;color:#fff;border-radius:8px;padding:6px 10px;font-size:13px;font-weight:600;max-width:220px;box-shadow:0 6px 20px rgba(0,0,0,.35)'
      document.body.appendChild(ghost)
      place(t0.clientX, t0.clientY)
      if (navigator.vibrate) navigator.vibrate(10)
    }, HOLD_MS)
    const move = ev => {
      const p = ev.touches[0]
      if (!active) { if (Math.hypot(p.clientX - t0.clientX, p.clientY - t0.clientY) > MOVE_TOLERANCE) cleanup(); return }
      ev.preventDefault()
      place(p.clientX, p.clientY)
      const c = cellAt(document.elementFromPoint(p.clientX, p.clientY))
      paint(c)
      // near the edge of the board: it scrolls along
      const box = c && c.el.closest('[data-service="week"]')
      if (box) { const r = box.getBoundingClientRect(); if (p.clientX > r.right - 40) box.scrollLeft += 16; else if (p.clientX < r.left + 40) box.scrollLeft -= 16 }
    }
    const end = ev => {
      const drop = active && cell ? { day: cell.day, tech: cell.tech } : null, was = active
      cleanup()
      if (was) { justDragged.current = true; setTimeout(() => { justDragged.current = false }, 400); if (ev.cancelable) ev.preventDefault() }
      if (drop) onDrop(id, drop.day, drop.tech)
    }
    const cancel = () => cleanup()
    document.addEventListener('touchmove', move, { passive: false })
    document.addEventListener('touchend', end)
    document.addEventListener('touchcancel', cancel)
  }
  // on a job card: drag by touch; a tap still opens it; no long-press menu
  return { start, wasDrag: () => justDragged.current }
}
